import { render } from "./BestDealShelf.vue?vue&type=template&id=2b00b69b&scoped=true"
import script from "./BestDealShelf.vue?vue&type=script&lang=js"
export * from "./BestDealShelf.vue?vue&type=script&lang=js"

import "./BestDealShelf.vue?vue&type=style&index=0&id=2b00b69b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b00b69b"]])

export default __exports__